import React from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import { PageConstant } from '../../../../constants';

function NoFlow ({ goto }) {
  return (
    <div className='Vetsmith-NoFlow-content'>
      <div className='Instructions-body'>
        <div>
          <h2>It seems like this selection process<br />is no longer active, but worry not!</h2>
          <p style={{ whiteSpace: 'pre-line' }}>You can still complete our vetting process to be elegible for multiple jobs with top US companies. Visit the Talent Portal to finish your profile and application.</p>
          <div className='Vetsmith-btn-list'>
            <Button type='primary' onClick={() => {
              localStorage.removeItem('redirect_url');
              goto(PageConstant.DASHBOARD_DEV);
            }}>Go to Talent Portal</Button>
            <Button onClick={() => goto('https://www.turing.com/')}>Visit turing.com</Button>
          </div>
        </div>
        <img className='contentimage' src='/images/vetsmith-hero.png' alt='Vetsmith-Instructions' />
      </div>
    </div>
  );
}

NoFlow.propTypes = {
  goto: PropTypes.func
};

export default NoFlow;
